module.exports = __webpack_public_path__ + "img/4 - 5 - 1.4ba264a1.jpg";